import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://1286c933fc01108f4b084e0806e56045@o4510379416223744.ingest.us.sentry.io/4510379519705088",
});
